import { useEffect, useRef } from 'react';

/**
 * TODO: 1차 오픈 이후에 사용하는 곳에서 import하지 않고
 * react-hook-form을 사용하지 않는 api의 경우 전역적으로 사용할 수 있도록 개선 필요
 */
export const useAbortController = () => {
  const controller = useRef<AbortController>(new AbortController());

  const abort = () => {
    controller.current.abort();
    controller.current = new AbortController();
  };

  const getSignal = () => controller.current.signal;

  useEffect(() => {
    return () => {
      controller.current.abort();
    };
  }, []);

  return {
    controller: {
      abort,
      getSignal
    }
  };
};
